import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/scss/tailwind.scss'
import '@/assets/libs/@mdi/font/css/materialdesignicons.min.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import Vue3Toastify  from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
const pinia = createPinia()





 const app = createApp(App)
 app.use(VueQueryPlugin)
 app.use(VueDatePicker)
 app.use(Vue3Toastify)
 app.use(pinia)
 app.use(router)
 app.mount('#app')
